import Repository from './Repository'

const resource = `ranking`

export default {
  getRanking (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  getRankingHorses (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/horses/`, { params: params })
  },
  getRankingRiders (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/riders/`, { params: params })
  },
  exportRanking (tenantId, params) {
    return Repository.get(`exports/tenants/${tenantId}/ranking/pdf`, {
      responseType: 'blob',
      params: params
    })
  },
  exportRankingHorses (tenantId, params) {
    return Repository.get(`exports/tenants/${tenantId}/ranking-horses/pdf`, {
      responseType: 'blob',
      params: params
    })
  },
  exportRankingRiders (tenantId, params) {
    return Repository.get(`exports/tenants/${tenantId}/ranking-riders/pdf`, {
      responseType: 'blob',
      params: params
    })
  }
}
